/* @ubm/ui/components/radio-cards — UIArc `radio-cards.module.css` @ 7238f98196b147a8d50ce467abcbad310d4d8414 (MIT). Jetons de fondation renommés `--arc-*`
   (U1/tools/arc_tokens.py) ; aucune autre modification. */
.root {
  position: relative;
  display: grid;
  gap: 10px;
  color: var(--arc-foreground);
  font-family: var(--arc-font-body);
  font-size: var(--arc-text-sm);
  letter-spacing: var(--arc-tracking-body);
  line-height: var(--arc-leading-body);
}
.root *, .root *::before, .root *::after { box-sizing: border-box; }
.root[data-layout="grid"] { grid-template-columns: repeat(auto-fill, minmax(min(100%, var(--min-column, 180px)), 1fr)); }
.root[data-layout="list"] { grid-template-columns: minmax(0, 1fr); gap: 8px; }

/* The one moving part: a ring that springs from card to card. It sits over the card border so the card itself never changes size. */
.ring {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  border: 1px solid var(--arc-control-on);
  border-radius: var(--radius);
  pointer-events: none;
}

.card {
  position: relative;
  display: grid;
  min-width: 0;
  align-items: start;
  gap: 4px 12px;
  padding: 14px 16px;
  border: 1px solid var(--arc-border);
  border-radius: var(--radius);
  background: var(--arc-surface);
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: background-color var(--arc-duration-fast) var(--arc-ease-standard), border-color var(--arc-duration-fast) var(--arc-ease-standard);
}
/* The body row takes any spare height, so prices sit on one baseline across a row even when a description wraps. */
.root[data-layout="grid"] .card { grid-template-areas: "body indicator" "meta meta"; grid-template-columns: minmax(0, 1fr) auto; grid-template-rows: minmax(0, 1fr) auto; }
.root[data-layout="list"] .card { grid-template-areas: "indicator body meta"; grid-template-columns: auto minmax(0, 1fr) auto; align-items: center; padding: 13px 16px 13px 14px; }
.card[data-checked] { background: color-mix(in oklab, var(--arc-control-on) 4%, var(--arc-surface)); }
.card[aria-disabled="true"] { background: var(--arc-surface-muted); cursor: not-allowed; }
.card[aria-disabled="true"] :is(.label, .meta) { color: var(--arc-text-muted); }

.indicator {
  display: grid;
  width: 18px;
  height: 18px;
  flex: none;
  place-items: center;
  grid-area: indicator;
  border: 1.5px solid var(--arc-border-strong);
  border-radius: 50%;
  transition: border-color var(--arc-duration-fast) var(--arc-ease-standard), background-color var(--arc-duration-fast) var(--arc-ease-standard);
}
.root[data-layout="grid"] .indicator { margin-top: 1px; }
.card[data-checked] .indicator { border-color: var(--arc-control-on); background: var(--arc-control-on); }
.indicatorDot { width: 6px; height: 6px; border-radius: 50%; background: var(--arc-control-glyph); }
.card[aria-disabled="true"] .indicator { border-color: var(--arc-border); }

.body { display: grid; min-width: 0; gap: 2px; grid-area: body; }
.label { display: flex; min-width: 0; align-items: center; gap: 8px; font-weight: 500; }
.labelText { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.icon { display: grid; width: 18px; height: 18px; flex: none; place-items: center; color: var(--arc-text-secondary); }
.icon > svg { width: 18px; height: 18px; }
.card[data-checked] .icon { color: var(--arc-foreground); }
.description { color: var(--arc-text-secondary); font-size: var(--arc-text-xs); line-height: var(--arc-leading-body); text-wrap: pretty; }

.meta { grid-area: meta; color: var(--arc-foreground); font-variant-numeric: tabular-nums; white-space: nowrap; }
.root[data-layout="grid"] .meta { margin-top: 10px; font-size: var(--arc-text-lg); }
.root[data-layout="list"] .meta { font-weight: 500; }

@media (hover: hover) and (pointer: fine) {
  .card:not([data-checked]):not([aria-disabled="true"]):hover { border-color: var(--arc-border-strong); }
}
.card:not([data-checked]):not([aria-disabled="true"]):active { background: var(--arc-surface-muted); }
.card:focus-visible:not([data-checked]) { border-color: var(--arc-border-strong); background: var(--arc-surface-muted); }

@media (prefers-reduced-motion: reduce) {
  .card, .indicator { transition: none; }
}
/* Foundry (lot U1) — mouvement réduit MANUEL : marqueur existant `[data-motion="reduced"]` (galerie / MotionConfig reducedMotion="always"), même règles que la préférence système. */
[data-motion="reduced"] .card, [data-motion="reduced"] .indicator { transition: none; }

/* Foundry (lot U1) — focus clavier visible (la source supposait aucun anneau ; invariant Foundry). */
.card:focus-visible { outline:1px solid var(--input-focus-color); outline-offset:0; box-shadow:none; }

@media(forced-colors:active){.card:focus-visible{outline-color:Highlight}.ring{border-color:Highlight}}
